import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../../shared/components/features/widget/Widget";
import pathRouts from "../../../../shared/enums/pathRoute";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import discoveryWidgetImg from '../../../../assests/discovery/discoveryWidget.png';
import classes from "./DiscoveryWidget.module.css";

const DiscoveryWidget = () => {

    const { texts } = useSelector(state => state.translate);
    
    return (
        <Widget
            color="#C3D48B"
            title={texts.ContentLibrary}
            icon={iconsList.discovery}
            className={classes.DiscoveryWidget}
            mainLink={`/${pathRouts.DISCOVERY}`}
        >
            <div className={classes.DiscoveryContent}>
                <img
                    src={discoveryWidgetImg}
                    alt={texts.discovery}
                    className={classes.DiscoveryImg}
                />
                <div className={classes.DiscoveryText}>
                    {texts.NeedMaterialForTomorrowClass}
                </div>
            </div>
        </Widget>
    );
};

export default DiscoveryWidget;
